var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddHiringTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513339"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2902",
    x: 0.25,
    y: 0.25,
    width: 25.5,
    height: 25.5,
    rx: 3.75,
    fill: "white",
    stroke: "#D7D7D7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 513337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M17.1094 17.1124H19.9983M18.5538 15.668V18.5569",
    stroke: "#1C4980",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M14.2222 15.668H10.6111C9.65339 15.668 8.73488 16.0484 8.05767 16.7256C7.38046 17.4029 7 18.3214 7 19.2791C7 19.4706 7.07609 19.6543 7.21153 19.7898C7.34698 19.9252 7.53068 20.0013 7.72222 20.0013H15.6667",
    stroke: "#5B6B79",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary_2",
    d: "M12.7795 12.7778C14.375 12.7778 15.6684 11.4844 15.6684 9.88889C15.6684 8.2934 14.375 7 12.7795 7C11.184 7 9.89062 8.2934 9.89062 9.88889C9.89062 11.4844 11.184 12.7778 12.7795 12.7778Z",
    stroke: "#5B6B79",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHiringTeam);
export default __webpack_public_path__ + "static/media/add_hiring_team.54ddb32a584f1e8987c305f7cfb427b3.svg";
export { ForwardRef as ReactComponent };